import useLayerListeners from './useLayerListeners';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import { Ref, WatchStopHandle } from 'vue';
import { LAYER_CONFIG_OMIT_PROP } from '../constants';

export default function useLabelLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<LabelLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config) return;

  const { id: layerId } = layerInfo.value;
  const { enableCollision } = toRefs(reactive(layerInfo.value.config));

  let labelStyle;
  let geometries;
  let unwatchList: WatchStopHandle[] | null = [];

  const labelLayer = new TMap.MultiLabel({
    id: layerId,
    enableCollision,
    map: mapInstance,
  });

  unwatchList.push(watchEffect(() => {
    const styleConfig = omit(layerInfo.value.config, LAYER_CONFIG_OMIT_PROP);
    const styleOption = mapValues(styleConfig, val => toRaw(unref(val)));
    labelStyle = new TMap.LabelStyle(styleOption);
    if (labelLayer) labelLayer.setStyles({ labelStyle });
  }));

  unwatchList.push(watchEffect(() => {
    if (!Array.isArray(layerInfo.value.config.data)) return;
    try {
      geometries = layerInfo.value.config.data.map((geometry: LabelGeometry, index: number) => {
        const { id, position, rank, content } = geometry;
        return {
          id: id ? id : `${index}`,
          position: new TMap.LatLng(position.lat, position.lng),
          rank: rank ? rank : index,
          content,
          styleId: 'labelStyle',
        };
      });
      if (labelLayer) labelLayer.setGeometries(geometries);
    } catch (error) {
      labelLayer?.setGeometries([]);
    }
  }));


  // 用户传入的事件回调在这里处理
  unwatchList.push(watchEffect(() => {
    useLayerListeners(labelLayer, [
      { eventName: 'click', callbackList: layerInfo.value.config.onClick },
      { eventName: 'hover', callbackList: layerInfo.value.config.onHover },
    ]);
  }));

  labelLayer.unmount = (): void => {
    labelLayer?.destroy();
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };

  return labelLayer;
}
